// extracted by mini-css-extract-plugin
module.exports = {"list":"BaseList_list__3fZH-"};